import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocales } from 'src/app/initialization/locales-init';

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

registerLocales();

// eslint-disable-next-line no-console
bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
